<template>
    <HomePage></HomePage>
    <MediaOverlay></MediaOverlay>
</template>
<script>
import HomePage from './components/pages/HomePage'
//import gsap, {} from "gsap/all";
import MediaOverlay from "./components/framework/MediaOverlay";
export default {
    name: 'App',
    components: {
        MediaOverlay,
        HomePage,
    },
    data() {
        return {
            window: window,
            document: document,
            showIt: false
        }
    },
    mounted() {
        //console.clear()
        let t = "%c ✨ We Can Be Heroes - https://heroic.art ✨"
        let n = ["font-size: 12px", "color: #fffce1", "font-family: monospace", "background: #0e100f", "display: inline-block", "padding: 1rem 3rem", "border: 1px solid #fffce1", "border-radius: 4px;"].join(";");
        console.info(t, n)

        this.window.addEventListener('resize', this.resize)
        this.resize()
        setTimeout(this.reveal, 300)
        setTimeout(this.reveal, 1000)
    },
    methods: {
        resize() {
            let vh = this.window.innerHeight * 0.01;
            this.document.documentElement.style.setProperty('--vh', `${vh}px`)

        },
        reveal() {

        }

    }
}
</script>
<style lang="scss">
@import "./assets/scss/app.scss";
</style>